/**
 * Bus VueUse (`useEventBus`) : la sidebar de `LayoutWithSidebar` est développée (non repliée).
 * Payload `true` lorsque la barre est ouverte et visible au-dessus du contenu ; `false` sinon.
 */
export const LAYOUT_SIDEBAR_EXPANDED_EVENT = "layout:sidebar-expanded"
